// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_3gbw53Z3GndBRktESDYn6G"};